import React from "react";
import PropTypes from "prop-types";
import { Input } from "rbx";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us";

function PhoneNumberInput({ name, value, onChange, size, ...props }) {
  return (
    <Input
      as={Cleave}
      autocomplete="new"
      name={name}
      options={{ phone: true, delimiter: "-", phoneRegionCode: "US" }}
      size={size}
      type="tel"
      value={typeof value === "string" ? value : ""}
      onChange={onChange}
      {...props}
    />
  );
}
PhoneNumberInput.propTypes = {
  size: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default PhoneNumberInput;
